import { v4 as uuid } from 'uuid'
import { mirrorFromOppositeSide as mirrorFromOppositeSideAction } from './vaultSlice' // A plain action to update state

export const mirrorFromOppositeSide = (payload) => (dispatch, getState) => {
    const state = getState()
    const { wallIndex } = payload
    const planDimension = wallIndex === 1 ? state.plan.length : state.plan.width
    const sourceWall = wallIndex === 1 ? state.plan.vault.walls[0] : state.plan.vault.walls[2]
    const mirroredWall = {
        sleeves: sourceWall.sleeves.map(item => ({
            ...item,
            id: uuid(),
            x: planDimension - item.x
        })),
        blockOuts: sourceWall.blockOuts.map(item => ({
            ...item,
            id: uuid(),
            x: planDimension - item.x - item.width
        })),
        drainages: sourceWall.drainages.map(item => ({
            ...item,
            id: uuid(),
            x: planDimension - item.x
        })),
        groundings: sourceWall.groundings.map(item => ({
            ...item,
            id: uuid(),
            x: planDimension - item.x
        })),
        cRails: sourceWall.cRails.map(item => {
            const x = planDimension - item.x - (item.orientation === 'horizontal' ? item.length : 0)
            return {
                ...item,
                id: uuid(),
                x
            }
        })
    }

    dispatch(mirrorFromOppositeSideAction({ wallIndex, mirroredWall }))
}